import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import "../Styles/Profile.css";
import { LogOutModel } from "./LogOutModel";
import UserWhite from "../Images/profile-image.png";
import ProfileIcon from "../assets/img/profile-icon1.png";
import ProfileIcon2 from "../assets/img/profile-icon2.png";
import LogoutIcon from "../assets/img/logout.png";
import ProfileIcon4 from "../assets/img/profile-icon4.png";
import { useUser } from "../Contexts/UserContext";

type NavItem = {
  path: string;
  icon: string;
  labelKey: "Profile_tr" | "Favourite_tr" | "Help_tr";
};

const ProfileSidePanel = ({
  color: _color,
  ImageOfUser: _imageOfUser,
}: {
  color: string;
  ImageOfUser: any;
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
  const { userImg } = useUser();

  const UserIdentity = localStorage.getItem("UserId") as string;
  const UserName = localStorage.getItem("UserName");

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const navItems: NavItem[] = [
    { path: "/profile", icon: ProfileIcon, labelKey: "Profile_tr" },
    {
      path: "/profile/My-Favourites",
      icon: ProfileIcon2,
      labelKey: "Favourite_tr",
    },
    { path: "/profile/feedback", icon: ProfileIcon4, labelKey: "Help_tr" },
  ];

  const isActivePath = (path: string) => location.pathname === path;

  const handleNavClick = (item: NavItem) => {
    navigate(item.path);
  };

  return (
    <div className="col-lg-3">
      <div className="profile-sidebar">
        <div className="profile-sidebar-user">
          <div className="profile-avatar-wrap">
            {UserIdentity ? (
              <img
                id="userimg"
                src={userImg === "" ? UserWhite : userImg}
                title="User Image"
                alt="user"
                className="profile-avatar"
                onError={() =>
                  "https://gitaseva.org/assets/img/profile-image1.png"
                }
              />
            ) : (
              <img
                id="userimg"
                src={ProfileIcon}
                title="User Image"
                className="profile-avatar profile-avatar-placeholder"
                alt="user"
              />
            )}
          </div>
          <h6 className="profile-sidebar-name">{UserName}</h6>
        </div>

        <ul className="profile-nav">
          {navItems.map((item) => (
            <li
              key={item.path}
              className={`profile-nav-item${isActivePath(item.path) ? " active" : ""}`}
              onClick={() => handleNavClick(item)}
            >
              <img src={item.icon} alt="" />
              <span className="profile-nav-label">{t(item.labelKey)}</span>
            </li>
          ))}
          <li
            className="profile-nav-item"
            onClick={() => setIsDialogOpen(true)}
          >
            <img src={LogoutIcon} alt="" />
            <span className="profile-nav-label">{t("LogOut_tr")}</span>
          </li>
        </ul>

        <LogOutModel open={isDialogOpen} onClose={handleCloseDialog} />
      </div>
    </div>
  );
};

export default ProfileSidePanel;
